(ns common.widgets.input
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/InputAdornment$default" :as InputAdornment]
            ["@mui/material/OutlinedInput$default" :as OutlinedInput]
            [common.util :as util :refer [spread-obj]]
            [common.widgets.interop :as interop]
            [uix.core :refer [$ defui]]))

(defui input
  [{:keys [value icon inputProps multiline
           data-component data-label-type data-lpignore data-testid]
    :or {data-lpignore true}
    :as props
    :& rest}]
  (let [controlled? (contains? props :value)]
    ($ OutlinedInput
       {:inputProps (spread-obj inputProps
                                #js {:data-component data-component
                                     :data-testid data-testid
                                     :data-label-type data-label-type
                                     :data-lpignore data-lpignore})
        :value (when controlled? (or value ""))
        :inputComponent (when controlled?
                          (if multiline
                            interop/textarea-component
                            interop/input-component))
        :startAdornment (when icon
                          ($ InputAdornment
                             {:position "start"}
                             ($ Icon icon)))
        :& rest})))
